<main class="middle-content">
    <!-- Page Title Start -->
    <div class="page_title_block">
        <h1 class="page_title" style="color:black">View Employer/Contractor</h1>
    </div>
    <!-- Page Title End -->

    <!-- Table responsive Start -->
    <div class="content-section">
        <form>
            <div class="outer-box">
                <div class="custom_tabs common-tabs">
                    <div class="tab-content card" style="padding: 2%; max-width: 850px; margin: auto;">

                        <div class="myAlign">
                            <div class="form-group row ">
                                <label class="col-md-5 bold">Company Name</label>
                                <span class="col-md-1">:</span>
                                <span class="col-md-6">{{hirerView?.companyName||'--'}}</span>

                            </div>

                            <div class="form-group row">
                                <label class="col-md-5 bold">First Name</label>
                                <span class="col-md-1">:</span>
                                <span class="col-md-6">{{hirerView?.firstName||'--'}}</span>

                            </div>

                            <div class="form-group row">
                                <label class="col-md-5 bold">Last Name</label>
                                <span class="col-md-1">:</span>
                                <span class="col-md-6">{{hirerView?.lastName||'--'}}</span>

                            </div>

                            <div class="form-group row">
                                <label class="col-md-5 bold">Email</label>
                                <span class="col-md-1">:</span>
                                <span class="col-md-6">{{hirerView?.email||'--'}}</span>

                            </div>

                            <div class="form-group row">
                                <label class="col-md-5 bold">Mobile Number
    
                                </label>
                                <span class="col-md-1">:</span>
                                <span class="col-md-6">{{(hirerView?.mobileNumber| mask: '(000) 000 0000')||'--'}}</span>

                            </div>

                            <div class="form-group row">
                                <label class="col-md-5 bold">Account Type
    
                                </label>
                                <span class="col-md-1">:</span>
                                <span class="col-md-6">{{ (hirerView?.account_Types?.accountName | split) ||'--'}}</span>

                            </div>

                            <div class="form-group row">

                                <label class="col-md-5 bold">Status
    
    
                                </label>
                                <span class="col-md-1">:</span>

                                <span class="col-md-6">{{hirerView?.status||'--'}}</span>

                            </div>

                            <div class="form-group row">
                                <label class="col-md-5 bold">Zip Code
    
                                </label>
                                <span class="col-md-1">:</span>
                                <span class="col-md-6">{{hirerView?.zipCode||'--'}}</span>

                            </div>
                        </div>
                        <div style="text-align: center">
                            <button class="btn  btn-button" type="button" (click)="back()">Back</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <!-- Table Responsive End -->
    </div>
</main>